import React, { Component } from 'react'
import { connect } from 'react-redux'
//import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {attendanceSummaryTableReady,rowsPerPageState,paginationState} from '../redux/attendance_summary'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
//import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import * as Helpers from '../../../common/helpers'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/attendanceSummaryTable.css'


import DateTimeField from "react-bootstrap-datetimepicker";




import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'


// import {Cities} from '../../../common/DropDowns/index'


import {Cities,Kitchens} from '../../../common/DropDowns/index'


//import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'


function filterUnwantedData(responseData,brandGroup) {
    let array = []
    if (responseData && responseData.data && responseData.data) {
        array = responseData.data
    }

    let newArray = []

    for (let i = 0; i < array.length; i++) {        

        for (let j = 0; j < 3; j++) {

            let row={};
            row.id=array[i]['id'];
            //row.name=array[i]['name']+" - "+array[i]['code'];
            row.name=array[i]['code'];

            switch(j) {
                  case 0:
                    row.header="Budgeted Counts";  
                    row.data=getBrandGroupsCounts(array[i]['budgeted_count'],brandGroup);                  
                    break;
                  case 1:
                    row.header="Actual Counts";
                    row.data=getBrandGroupsCounts(array[i]['actual_count'],brandGroup);            
                    break;
                  case 2:
                    row.header="Attendance";
                    row.data=getBrandGroupsCounts(array[i]['attendance_count'],brandGroup);                   
                    break;
                  default:
                    
                }
                newArray.push(row);

        }

    } 
    return newArray
}

function getBrandGroupsCounts(data,brandGroup) {

    let row={};

    row['km']=data['km'] ? data['km'] : 0;
    row['akm']=data['akm'] ? data['akm'] : 0;
    row['sm']=data['sm'] ? data['sm'] : 0;
    row['hk']=data['hk'] ? data['hk'] : 0;

    for (var i = 0; i < brandGroup.length; i++) {
        row[brandGroup[i]['name']]=data[brandGroup[i]['name']] ? data[brandGroup[i]['name']] : 0
    }

    row["not assigned"]=data["not assigned"] ? data["not assigned"] : 0;
    return row;
}


class AttendanceSummaryTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            attendanceSummaryData: [],
            allCity:{},
            cityWise:[],
            brandGroup:[],
            query_datetime:"",
            filter_city_id:"",
            filter_kitchen_id:"",
            headCountDate:Helpers.getDateFormatForUTC(new Date()),
            minDate:moment(new Date("2022-10-13")),
            reportDate:Helpers.getDateFormatForUTC(new Date()),
            bodyHeight: "0px",
            tableHeight: "0px",
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            ranges: {
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Yesterday': [moment().subtract(1, 'day'), moment().subtract(1, 'day')]
            },
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null

        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)

         
    }


    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(attendanceSummaryTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.ATTENDANCE_SUMMARY_TABLE))
        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()


        this.getBrandGroups();
        
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 80) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }

    cityChange = (data) => {
         this.setState({
                filter_city_id :data.value,
        })
     }

      kitchenChange = (data) => {
         this.setState({
                filter_kitchen_id :data.value,
        })
     }
    
    getAttendanceSummaryData = () => {
        let reportDate=this.state.headCountDate
        if(moment(new Date(this.state.headCountDate)).format("DD-MM-YYYY")===moment(new Date()).format("DD-MM-YYYY")){
            reportDate="";
        }
        apiService.getAttendanceSummaryData(reportDate,this.state.filter_city_id,this.state.filter_kitchen_id)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData,this.state.brandGroup), pageNo = 1
                        if (this.props.attendance_summary && this.props.attendance_summary.previousPaginationValue) {
                            pageNo = this.props.attendance_summary.previousPaginationValue
                        }
                        this.setState({
                            attendanceSummaryData:array,
                            page: pageNo,
                            query_datetime:responseData.query_datetime
                        })


                        this.createCSVData(array)
                        
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(attendanceSummaryTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(attendanceSummaryTableReady(true))
                if (this.isComponentMounted) {
                    //this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }


    getBrandGroups=()=>{
         apiService.getBrandGroupsCombo()
                .then(responseData => {
                    //this.props.dispatch(attendanceSummaryTableReady(true))
                    if(responseData.status === "SUCCESS") {
                         let list = {}
                            list = Object.keys(responseData.data).map((value,index) => {
                                
                                return {
                                    name : responseData.data[value],
                                    id:value
                                }
                            })
                            list.sort((a,b) => a.name.localeCompare(b.name));

                            let brandGroup=[]
                            for (var i = list.length - 1; i >= 0; i--) {
                                if(list[i]['name']!=="OTHERS"){
                                    brandGroup.push(list[i])
                                }
                            }

                            this.setState({
                                brandGroup: brandGroup
                            },() => {   
                                this.getAttendanceSummaryData()
                            });
                    }
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(attendanceSummaryTableReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Getting store groups got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                        }
                    })
                })
        
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.attendance_summary && this.props.attendance_summary.previousRowsPerPageValue) {
            value = this.props.attendance_summary.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

   
    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

     renderLocation = (cell, row, enumObject, rowIndex,) => {
        
        let location=""
        
            location=<p>{row.work_location} - {row.city_name}</p>

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{location}</div>
        </div>)
    }

      headCountDateChange = (newDate) => {

        let headCountDate=Helpers.getDateFormatForUTC(parseInt(newDate,10));

        this.setState({
            headCountDate: headCountDate
        })

    }




    renderCreatedFormat = (cell, row, enumObject, rowIndex,) => {
                let dateTemp="NA"

        if(row.created){
            dateTemp=Helpers.getDateTimeFormatForUTC(row.created)
        }
        
         
        return (<p>{dateTemp}</p>)
    }


    createCustomToolBar = props => {

        let headCountFilename = "headCountReport_" +this.state.reportDate+"_"+moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"

       

        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-div-margins">

                <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <DateTimeField startDate="13-10-2022" minDate={this.state.minDate} maxDate={moment()} mode="date" inputFormat="DD-MM-YYYY" dateTime={new Date(this.state.headCountDate)} onChange={this.headCountDateChange}/>
                    </div>
            

                      <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <Cities cityChange={this.cityChange} selectedValue={this.state.filter_city_id} />   
                    </div>
                    </div>

                
                     {(() => {
                        if(this.state.filter_city_id && this.state.filter_city_id!=="" && this.state.filter_city_id!==undefined){
                            return(
                           <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                            <div className="form-group">
                                <Kitchens kitchenChange={this.kitchenChange} selectedCity={this.state.filter_city_id} selectedValue={this.state.filter_kitchen_id} />   
                            </div>
                            </div>
                            )
                        }
                    })()}
 

                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredAttendanceSummaryList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>

                        <CSVLink
                            data={this.CSVData}
                            className="btn btn-primary button-custom"
                            style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                            filename={headCountFilename}>
                            Export
                        </CSVLink>
                    </div>
                    <div className="col-md-5 col-sm-12 col-xs-12 div-margins" style={{float: "right",textAlign:"right",fontSize: "1.2em",color: "red"}}>

                    Report as on  : {this.state.query_datetime}

                    </div>
                   
                   
                </div>
            </div>
        )
    }




  createCSVData(csvData) {
        let headCountList = []
        if (csvData) {
            headCountList = JSON.parse(JSON.stringify(csvData))
            headCountList = createXLSheetdata(headCountList,this.state.brandGroup)
        }
        this.CSVData = headCountList
    }

    
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.attendanceSummaryData.length>=(this.props.attendance_summary.previousPaginationValue*this.props.attendance_summary.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.attendance_summary.previousPaginationValue*this.props.attendance_summary.previousRowsPerPageValue)-this.props.attendance_summary.previousRowsPerPageValue+1} to {this.props.attendance_summary.previousPaginationValue*this.props.attendance_summary.previousRowsPerPageValue} of {this.state.attendanceSummaryData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.attendance_summary.previousPaginationValue*this.props.attendance_summary.previousRowsPerPageValue)-this.props.attendance_summary.previousRowsPerPageValue+1} to {this.state.attendanceSummaryData.length} of {this.state.attendanceSummaryData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredAttendanceSummaryList = () => {
       
        this.props.dispatch(attendanceSummaryTableReady(false))
        this.setState({
            reportDate:this.state.headCountDate
        });
        this.getBrandGroups()
       
    }

   

    

    resetFilterValues = () => {
        this.props.dispatch(attendanceSummaryTableReady(false))
        this.setState({
            headCountDate:Helpers.getDateFormatForUTC(new Date()),
            reportDate:Helpers.getDateFormatForUTC(new Date()),
            filter_city_id:"",
            filter_kitchen_id:"", 
        },()=>{
        this.getBrandGroups();

        });
    }


     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    
   
    render() {
       
        return (

        <div className="react-bs-table-container attendance-summary-div">
   {this.createCustomToolBar()}
   <div className="attendance-summary-table" style={{ marginBottom: '0px',background: "white",padding: "1%" , height: this.state.bodyHeight,overflow: "auto" }}>
   <Dialog ref={el =>
   this.dialog = el} />
   <div className="row" style={{padding: "0% 2%"}} >
      <div className="col-sm-12">
         <h4 className="report-header">Brand Wise Budgeted [{this.state.reportDate}]</h4>
      </div>
      <div className="attendance-summary" style={{ marginBottom: '0px', minWidth:"100%",height: this.state.tableHeight,overflow: "auto" }}>
        <table className="table table-bordered table-hover" style={{textAlign:"center"}}>
            <thead>
                <tr>
                    <th>Outlet</th>
                    <th>Header</th>
                    <th>Kitchen Manager</th>
                    <th>Asst. Kitchen Manager</th>
                    <th>Shift Manager</th>
                    <th>House Keeping</th>
                    {this.state.brandGroup.map((item, index) => (
                        <th>{item.name}</th>
                    ))}
                    <th>Not Assigned</th>
                    
                </tr>
            </thead>
            <tbody>
                {this.state.attendanceSummaryData.map((item, index) => (
                        <tr>

                        {(() => {
                        
                            if(item.header==="Budgeted Counts"){
                                 return(
                                     <td rowspan="3" style={{verticalAlign: "middle"}}>{item.name}</td>
                                 )
                            }
                        })()}

                        <td>{item.header}</td>

                                    <td>
                                        {(() => {
                                            if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['km'] > item.data['km']){
                                                return(
                                                    <p className="count-yellow">{item.data['km']}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['km'] === item.data['km']){
                                                return(
                                                    <p className="count-green">{item.data['km']}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['km'] < item.data['km']){
                                                return(
                                                    <p className="count-red">{item.data['km']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['km'] > item.data['km']){
                                                return(
                                                    <p className="count-yellow">{item.data['km']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['km'] === item.data['km']){
                                                return(
                                                    <p className="count-green">{item.data['km']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['km'] < item.data['km']){
                                                return(
                                                    <p className="count-red">{item.data['km']}</p>
                                                )
                                            }else{
                                                return(
                                                <p>{item.data['km']}</p>
                                                )
                                            }

                                        })()}

                                    </td>

                         <td>
                                        {(() => {
                                            if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['akm'] > item.data['akm']){
                                                return(
                                                    <p className="count-yellow">{item.data['akm']}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['akm'] === item.data['akm']){
                                                return(
                                                    <p className="count-green">{item.data['akm']}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['akm'] < item.data['akm']){
                                                return(
                                                    <p className="count-red">{item.data['akm']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['akm'] > item.data['akm']){
                                                return(
                                                    <p className="count-yellow">{item.data['akm']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['akm'] === item.data['akm']){
                                                return(
                                                    <p className="count-green">{item.data['akm']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['akm'] < item.data['akm']){
                                                return(
                                                    <p className="count-red">{item.data['akm']}</p>
                                                )
                                            }else{
                                                return(
                                                <p>{item.data['akm']}</p>
                                                )
                                            }

                                        })()}

                                    </td>



                         <td>
                                        {(() => {
                                            if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['sm'] > item.data['sm']){
                                                return(
                                                    <p className="count-yellow">{item.data['sm']}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['sm'] === item.data['sm']){
                                                return(
                                                    <p className="count-green">{item.data['sm']}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['sm'] < item.data['sm']){
                                                return(
                                                    <p className="count-red">{item.data['sm']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['sm'] > item.data['sm']){
                                                return(
                                                    <p className="count-yellow">{item.data['sm']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['sm'] === item.data['sm']){
                                                return(
                                                    <p className="count-green">{item.data['sm']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['sm'] < item.data['sm']){
                                                return(
                                                    <p className="count-red">{item.data['sm']}</p>
                                                )
                                            }else{
                                                return(
                                                <p>{item.data['sm']}</p>
                                                )
                                            }

                                        })()}

                                    </td>




                       <td>
                                        {(() => {
                                            if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['hk'] > item.data['hk']){
                                                return(
                                                    <p className="count-yellow">{item.data['hk']}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['hk'] === item.data['hk']){
                                                return(
                                                    <p className="count-green">{item.data['hk']}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['hk'] < item.data['hk']){
                                                return(
                                                    <p className="count-red">{item.data['hk']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['hk'] > item.data['hk']){
                                                return(
                                                    <p className="count-yellow">{item.data['hk']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['hk'] === item.data['hk']){
                                                return(
                                                    <p className="count-green">{item.data['hk']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['hk'] < item.data['hk']){
                                                return(
                                                    <p className="count-red">{item.data['hk']}</p>
                                                )
                                            }else{
                                                return(
                                                <p>{item.data['hk']}</p>
                                                )
                                            }

                                        })()}

                                    </td>


                    {this.state.brandGroup.map((item2, index2) => (
                        <td>

                       {(() => {
                                            if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data[item2.name] > item.data[item2.name]){
                                                return(
                                                    <p className="count-yellow">{item.data[item2.name]}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data[item2.name] === item.data[item2.name]){
                                                return(
                                                    <p className="count-green">{item.data[item2.name]}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data[item2.name] < item.data[item2.name]){
                                                return(
                                                    <p className="count-red">{item.data[item2.name]}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data[item2.name] > item.data[item2.name]){
                                                return(
                                                    <p className="count-yellow">{item.data[item2.name]}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data[item2.name] === item.data[item2.name]){
                                                return(
                                                    <p className="count-green">{item.data[item2.name]}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data[item2.name] < item.data[item2.name]){
                                                return(
                                                    <p className="count-red">{item.data[item2.name]}</p>
                                                )
                                            }else{
                                                return(
                                                <p>{item.data[item2.name]}</p>
                                                )
                                            }

                                        })()}

                        </td>
                    ))}

                    <td>
                                        {(() => {
                                            if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['not assigned'] > item.data['not assigned']){
                                                return(
                                                    <p className="count-yellow">{item.data['not assigned']}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['not assigned'] === item.data['not assigned']){
                                                return(
                                                    <p className="count-green">{item.data['not assigned']}</p>
                                                )
                                            }else if(item.header==="Actual Counts" && this.state.attendanceSummaryData[index-1].data['not assigned'] < item.data['not assigned']){
                                                return(
                                                    <p className="count-red">{item.data['not assigned']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['not assigned'] > item.data['not assigned']){
                                                return(
                                                    <p className="count-yellow">{item.data['not assigned']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['not assigned'] === item.data['not assigned']){
                                                return(
                                                    <p className="count-green">{item.data['not assigned']}</p>
                                                )
                                            }else if(item.header==="Attendance" && this.state.attendanceSummaryData[index-1].data['not assigned'] < item.data['not assigned']){
                                                return(
                                                    <p className="count-red">{item.data['not assigned']}</p>
                                                )
                                            }else{
                                                return(
                                                <p>{item.data['not assigned']}</p>
                                                )
                                            }

                                        })()}

                                    </td>





                        </tr>
                    ))}
            </tbody>
        </table>
      </div>
     
   </div>





</div>


</div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        attendance_summary: state.attendance_summary
    }
}

export default connect(mapStateToProps)(withRouter(AttendanceSummaryTable))


// WEBPACK FOOTER //
// ./src/modules/Attendance Summary/Components/AttendanceSummaryTable.js